import React from 'react';
import { IMAGES } from 'src/shared/utils/appConstant';
import { IOT_STRINGS, cardDataSecuritySurveillance } from 'src/shared/utils/string';
import IOTServicePage from './IOTServicePage';

const SecuritySurveillance: React.FC = () => {
  return (
    <IOTServicePage
      title={IOT_STRINGS.SECURITY_SURVEILLANCE}
      backgroundImage={IMAGES.SECURITY_SURVEILLANCE_BANNER}
      cardData={cardDataSecuritySurveillance}
    />
  );
};

export default SecuritySurveillance;